import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, DropdownItem } from 'reactstrap';
import FormSelect from '../../FormSelect/FormSelect';
import {isMobile} from 'react-device-detect';
import { GetUnoccupancyCodes } from '../../../utils/ApplicationApi';

class StatusField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unoccupancyCodeList: []
    };

    this.handleStatus = this.handleStatus.bind(this);
  }
  componentDidMount() {
    this.mounted = true;
    if(this.state.unoccupancyCodeList.length === 0) {
      GetUnoccupancyCodes().then(list => {
        if(this.mounted) {
          this.setState ({unoccupancyCodeList : list});
        }
      })
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  handleStatus(event) {
    if(event.target.value.indexOf("|") !== -1) {
      const empStatus = event.target.value.split("|")[0];
      const noc = event.target.value.split("|")[1];
      this.props.handleChange({target: {name: "status", value: {status: empStatus, noc: noc, industry: "", occupationName: "", employer: "", employedSince: "", phone: ""}}});
    }
    else {
      this.props.handleChange({target: {name: "status", value: {status: event.target.value}}});
    }
  }
  render() {
    let label = this.props.status;

    if(this.props.status === "SelfEmployed") {
      label = "Self-Employed";
    }
    else if(this.props.status === "SocialAssit") {
      label = "On disability assistance";
    }
    return (
      <div>
        <FormGroup>
          <Label for="status">Occupation Status</Label>
          {isMobile ? 
            <Input type="select" name="status" id="status" value={this.props.status === "" ? "" : `${this.props.status}|${this.props.noc}`} onChange={this.handleStatus} autoFocus={this.props.autoFocus}>
              <option value="Employed">Employed</option>
              <option value="SelfEmployed">Self-Employed</option>
              {this.state.unoccupancyCodeList.map((status, i) => <option key={i} value={`${status.employmentStatus}|${status.code}`}>{status.text}</option>)}
            </Input>
          :
            <FormSelect name="status" handleChange={this.handleStatus} value={this.props.status === "" ? "" : `${this.props.status}|${this.props.noc}`} label={label} autoFocus={this.props.autoFocus}>
              <DropdownItem value="Employed">Employed</DropdownItem>
              <DropdownItem value="SelfEmployed">Self-Employed</DropdownItem>
              {this.state.unoccupancyCodeList.map((status, i) => <DropdownItem key={i} value={`${status.employmentStatus}|${status.code}`}>{status.text}</DropdownItem>)}
            </FormSelect>
          }
        </FormGroup>                                                
      </div>);
  }
}
StatusField.defaultProps= {
  handleChange:() => {},
  autoFocus: false
};

StatusField.propTypes = {
  handleChange: PropTypes.func,
  autoFocus: PropTypes.bool
};

export default StatusField;


// WEBPACK FOOTER //
// ./src/components/Fields/Occupation/StatusField.js